import { ReportConfig } from "../definitions";

const dashboard: ReportConfig = {
  id: "dashboard",
  name: "Dashboard CCTV",
  options: [],
  layout: [
    {
      items: [
        {
          id: "item-1",
          title: "Carrier Paid Production YTD",
          widgetType: "table",
          columns: [
            { name: "Carrier", type: "string" },
            { name: "2024", type: "currency", align: "right", summary: "sum" },
            { name: "2025", type: "currency", align: "right", summary: "sum" },
            { name: "YTD %", type: "percent", align: "right", summary: "percent" },
          ],
          dataSource: {
            sql: `
          declare @StartCY datetime
declare @EndCY datetime

declare @StartPY datetime
declare @EndPY datetime

set @StartCY = DATEFROMPARTS(YEAR(GETDATE()), 1, 1) --first of current year
set @EndCY =  GETDATE() --end of current year


--two years of data YTD. do not use report params
declare @CurrentYear int
set @CurrentYear = Year(@EndCY)

set @StartPY = dateadd(year, -1, @StartCY) --subtract one year
set @EndPY = dateadd(year, -1, getdate());
With YearData as
(SELECT

		cr.type AS Carrier,
	 --prior year:
	SUM(Case When DatePart(YYYY,a.PaidOrClosedDate)=@CurrentYear-1 Then AnnualizedPremium ELSE 0 END) as PrevYTD,
		--current year:
	SUM(Case When DatePart(YYYY,a.PaidOrClosedDate)=@CurrentYear Then AnnualizedPremium ELSE 0 END) as CurrentYTD
	FROM awu.Application a
	INNER JOIN awu.ApplicationPremium ap ON a.ID = ap.ApplicationID
	LEFT JOIN dbo.CarrierType cr ON a.CarrierID = cr.ID
	left join awu.ApplicationStatus ast on a.ApplicationStatusID = ast.ID
	WHERE (
	        (a.PaidOrClosedDate BETWEEN @StartPY AND @EndPY) OR (a.PaidOrClosedDate BETWEEN @StartCY AND @EndCY)
		  )
	AND ast.Category = 'Paid' and ast.IsDeleted=0
	AND (@_branch = 0 OR a.BranchTypeID = @_branch)
	group by cr.type
)
	SELECT
	Carrier,
	PrevYTD,
	CurrentYTD,
	ROUND(CASE
        WHEN ISNULL(PrevYTD, 0) = 0 THEN 0
        ELSE ((ISNULL(CurrentYTD, 0) - ISNULL(PrevYTD, 0)) / PrevYTD)
    END,2) AS PercentageChange
	FROM YearData
	ORDER BY Carrier;
            `,
            returnType: "table",
          },
          options: { summary: true },
        },
        {
          id: "item-2",
          title: "Carrier Written Production YTD",
          widgetType: "table",
          columns: [
            { name: "Carrier", type: "string" },
            { name: "2024", type: "currency", align: "right", summary: "sum" },
            { name: "2025", type: "currency", align: "right", summary: "sum" },
            { name: "YTD %", type: "percent", align: "right", summary: "percent" },
          ],
          dataSource: {
            sql: `
          declare @StartCY datetime
declare @EndCY datetime

declare @StartPY datetime
declare @EndPY datetime

set @StartCY = DATEFROMPARTS(YEAR(GETDATE()), 1, 1) --first of current year
set @EndCY =  GETDATE() --end of current year


--two years of data YTD. do not use report params
declare @CurrentYear int
set @CurrentYear = Year(@EndCY)

set @StartPY = dateadd(year, -1, @StartCY) --subtract one year
set @EndPY = dateadd(year, -1, getdate());
With YearData AS
(SELECT

		cr.Type AS Carrier,
		--prior year:
	SUM(Case When DatePart(YYYY,a.EntryDate)=@CurrentYear-1 Then AnnualizedPremium ELSE 0 END) as PrevYTD,
		--current year:
	SUM(Case When DatePart(YYYY,a.EntryDate)=@CurrentYear Then AnnualizedPremium ELSE 0 END) as CurrentYTD
	FROM awu.[Application] a
	INNER JOIN awu.ApplicationPremium ap ON a.ID = ap.ApplicationID
	LEFT JOIN dbo.CarrierType cr ON a.CarrierID = cr.ID
	left join awu.ApplicationStatus ast on a.ApplicationStatusID = ast.ID
	WHERE (
	        (a.EntryDate BETWEEN @StartPY AND @EndPY) OR (a.EntryDate BETWEEN @StartCY AND @EndCY)
		  )

	AND ast.ScenarioTypeCode = 'F'
	AND (@_branch = 0 OR a.BranchTypeID = @_branch)

	group by cr.Type
)
SELECT
Carrier,
PrevYTD,
CurrentYTD,
ROUND(CASE
      WHEN ISNULL(PrevYTD, 0) = 0 THEN 0
      ELSE ((ISNULL(CurrentYTD, 0) - ISNULL(PrevYTD, 0)) / PrevYTD)
  END,2) AS PercentageChange
FROM YearData
ORDER BY Carrier;
            `,
            returnType: "table",
          },
          options: { summary: true },
        },
      ],
    },
    {
      items: [
        {
          id: "item-3",
          title: "Branch Paid Production YTD",
          widgetType: "table",
          columns: [
            { name: "Branch", type: "string" },
            { name: "2024", type: "currency", align: "right", summary: "sum" },
            { name: "2025", type: "currency", align: "right", summary: "sum" },
            { name: "YTD %", type: "percent", align: "right", summary: "percent" },
          ],
          dataSource: {
            sql: `
          declare @StartCY datetime
declare @EndCY datetime

declare @StartPY datetime
declare @EndPY datetime

set @StartCY = DATEFROMPARTS(YEAR(GETDATE()), 1, 1) --first of current year
set @EndCY =  GETDATE() --end of current year


--two years of data YTD. do not use report params
declare @CurrentYear int
set @CurrentYear = Year(@EndCY)

set @StartPY = dateadd(year, -1, @StartCY) --subtract one year
set @EndPY = dateadd(year, -1, getdate())
;
with cte as
(
SELECT
		case when o.Type ='AZ 2' then 'Phoenix' else o.Type end as [Branch],
		--current ytd:

	SUM(Case When DatePart(YYYY,c.PaidOrClosedDate)=@CurrentYear Then AnnualizedPremium ELSE 0 END) as CurrentYTD
		, --prior ytd:
	SUM(Case When DatePart(YYYY,c.PaidOrClosedDate)=@CurrentYear-1 Then AnnualizedPremium ELSE 0 END) as PrevYTD
	FROM awu.Application c
	INNER JOIN awu.ApplicationPremium cp ON c.ID = cp.ApplicationID
	INNER JOIN dbo.CarrierType cr ON c.CarrierID = cr.ID
	inner join dbo.BranchType o on c.BranchTypeID = o.ID

	WHERE (
	        (c.PaidOrClosedDate BETWEEN @StartPY AND @EndPY) OR (c.PaidOrClosedDate BETWEEN @StartCY AND @EndCY)
		  )
 AND c.isdeleted = 0
	AND c.ApplicationStatusID IN (33968,35250,36532)
	AND (@_branch = 0 OR c.BranchTypeID = @_branch)

	group by o.Type
)

select
Branch,
SUM(PrevYTD) PrevYTD,
SUM(CurrentYTD) as CurrentYTD,
	    ROUND(CASE
    WHEN ISNULL(SUM(PrevYTD), 0) = 0 THEN 0
ELSE ((ISNULL(SUM(CurrentYTD), 0) - ISNULL(SUM(PrevYTD), 0)) / ISNULL(SUM(PrevYTD), 0))
END, 2) AS PercentageChange

	from cte
group by Branch order by CurrentYTD desc

            `,
            returnType: "table",
          },
          options: { summary: true },
        },
        {
          id: "item-4",
          title: "Top 10 Brokers YTD",
          widgetType: "table",
          columns: [
            { name: "Broker", type: "string" },
            { name: "Branch", type: "string" },
            { name: "Premium", type: "currency", align: "right", summary: "sum" },
          ],
          dataSource: {
            sql: `
          declare @StartCY datetime
declare @EndCY datetime

declare @StartPY datetime
declare @EndPY datetime

set @StartCY = DATEFROMPARTS(YEAR(GETDATE()), 1, 1) --first of current year
set @EndCY =  GETDATE() --today


SELECT TOP 10

		Concat(e.[LastNAME],', ',e.FirstName) AS [Broker],o.Type as [Branch],
		--current year:

	SUM(AnnualizedPremium) as CurrentYTD
	FROM awu.[Application] c
	INNER JOIN awu.applicationpremium cp ON c.id = cp.ApplicationID
	INNER JOIN dbo.CarrierType cr ON c.CarrierID = cr.id
	INNER JOIN awu.ApplicationBroker ac On c.id = ac.ApplicationID
	INNER JOIN dbo.Broker e On ac.BrokerID = e.id
	inner join dbo.BranchType o on c.BranchTypeID = o.id

	WHERE (
	        c.PaidOrClosedDate BETWEEN @StartCY AND @EndCY
		  )

	AND c.ApplicationStatusID IN (33968,35250,36532)
	and c.isdeleted = 0
  AND (@_branch = 0 OR c.BranchTypeID = @_branch)
	group by Concat(e.[LastNAME],', ',e.FirstName) ,o.Type
	order by SUM(AnnualizedPremium) DESC
            `,
            returnType: "table",
          },
          options: { summary: true },
        },
      ],
    },
  ],
};

export default dashboard;
